"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSmallMultipleScalesSelector = void 0;
const get_internal_main_projection_area_1 = require("./get_internal_main_projection_area");
const get_internal_sm_domains_1 = require("./get_internal_sm_domains");
const get_small_multiples_spec_1 = require("./get_small_multiples_spec");
const create_selector_1 = require("../create_selector");
const get_small_multiples_scale_1 = require("../utils/get_small_multiples_scale");
exports.computeSmallMultipleScalesSelector = (0, create_selector_1.createCustomCachedSelector)([get_internal_sm_domains_1.getInternalSmallMultiplesDomains, get_internal_main_projection_area_1.getInternalMainProjectionAreaSelector, get_small_multiples_spec_1.getSmallMultiplesSpec], ({ smHDomain, smVDomain }, { width, height }, smSpec) => {
    return {
        horizontal: (0, get_small_multiples_scale_1.getSmallMultiplesScale)(smHDomain, width, smSpec?.style?.horizontalPanelPadding),
        vertical: (0, get_small_multiples_scale_1.getSmallMultiplesScale)(smVDomain, height, smSpec?.style?.verticalPanelPadding),
    };
});
//# sourceMappingURL=compute_small_multiple_scales.js.map